/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DataTable from "./DataTable";
import moment from "moment";
import RedtagIcon from "../assets/img/Redtag.PNG";
import DefectsIcon from "../assets/img/Defects.PNG";
import InspectionpastIcon from "../assets/img/Inspectionpast.PNG";
import InspectiondueIcon from "../assets/img/Inspectiondue.PNG";
import ReadytogoIcon from "../assets/img/Readytogo.PNG";
import { Row, Col } from "reactstrap";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import DoneIcon from "@material-ui/icons/Done";
import CloseIcon from "@material-ui/icons/Close";
import { stubTrue } from "lodash";
import { Link } from "react-router-dom";
import { Tooltip } from "@material-ui/core";

const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "2px solid rgba(0, 0, 0, .125)",
    marginBottom: 4,
    minHeight: 40,
    "&$expanded": {
      minHeight: 56
    }
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    }
  },
  expanded: {}
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(() => ({
  root: {
    padding: 2
  }
}))(MuiExpansionPanelDetails);

export default function DashboardView({ data, customer }) {
  const [expanded, setExpanded] = React.useState("");
  const [layer, setLayer] = React.useState(true);
  const [notReady, setNotReady] = useState(
    data.filter(c => {
      return (
        c.redTag ||
        c.defectCount > 0 ||
        moment(new Date(c.nextDue)).diff(new Date(), "days") <= 7 ||
        moment(new Date(c.nextDue)).diff(new Date(), "days") < 0
      );
    })
  );
  const Team = {
    Technicians:
      customer.customerTeam &&
      customer.customerTeam.items.filter(cc => cc.empType === "Technicians"),

    Dispatchers:
      customer.customerTeam &&
      customer.customerTeam.items.filter(cc => cc.empType === "Dispatchers"),

    Drivers:
      customer.customerTeam &&
      customer.customerTeam.items.filter(cc => cc.empType === "Drivers")
  };
  const critical = {
    title: "Upcoming Inspections Within 3 Days",
    data: data.filter(c => {
      return (
        moment(new Date(c.nextDue)).diff(new Date(), "days") < 3 &&
        moment(new Date(c.nextDue)).diff(new Date(), "days") >= 0
      );
    }),
    icon: RedtagIcon
  };
  const Tabs_Array = [
    {
      title: "Red Tags",
      tag: "red",
      data: data.filter(c => c.redTag),
      statement: "that has been red tagged",
      icon: RedtagIcon,
      table: "defects",
      heads: [
        {
          id: "id",
          label: "Vehicle ID"
        },
        { id: "make", label: "Make" },
        { id: "model", label: "Model" },
        { id: "vin", label: "VIN" },
        { id: "defects", label: "Defects" }
      ]
    },
    {
      title: "Past Due Inspections",
      tag: "past",
      data: data.filter(c => {
        return moment(new Date(c.nextDue)).diff(new Date(), "days") < 0;
      }),
      statement: "with inspections that are past due",
      icon: InspectionpastIcon,
      table: "inspections",
      heads: [
        {
          id: "id",
          label: "Vehicle ID"
        },
        { id: "make", label: "Make" },
        { id: "model", label: "Model" },
        { id: "vin", label: "VIN" },
        {
          id: "inspections",
          label: "Inspection Due By:"
        }
      ]
    },
    {
      title: "Defects",
      tag: "def",
      data: data.filter(c => !c.redTag && c.defectCount > 0),
      statement: "with defects that need attention",
      icon: DefectsIcon,
      table: "defects",
      heads: [
        {
          id: "id",
          label: "Vehicle ID"
        },
        { id: "make", label: "Make" },
        { id: "model", label: "Model" },
        { id: "vin", label: "VIN" },
        { id: "defects", label: "Defects" }
      ]
    },
    // {
    //   title: "Upcoming Inspections Within 3 Days",
    //   tag: "due(3)",
    //   data: data.filter(c => {
    //     return (
    //       moment(new Date(c.nextDue)).diff(new Date(), "days") < 3 &&
    //       moment(new Date(c.nextDue)).diff(new Date(), "days") >= 0
    //     );
    //   }),
    //   statement: "with inspections due within 3 Days",
    //   icon: RedtagIcon,
    //   table: "inspections",
    //   heads: [
    //     {
    //       id: "id",
    //       label: "Vehicle ID"
    //     },
    //     { id: "make", label: "Make" },
    //     { id: "model", label: "Model" },
    //     { id: "vin", label: "VIN" },
    //     {
    //       id: "inspections",
    //       label: "Inspection Due By:"
    //     }
    //   ]
    // },
    {
      title: "Upcoming Inspections",
      tag: "due",
      data: data.filter(c => {
        return (
          moment(new Date(c.nextDue)).diff(new Date(), "days") < 7 &&
          moment(new Date(c.nextDue)).diff(new Date(), "days") >= 0
        );
      }),
      statement: "with inspections due Within 7 Days",
      icon: InspectiondueIcon,
      table: "inspections",
      heads: [
        {
          id: "id",
          label: "Vehicle ID"
        },
        { id: "make", label: "Make" },
        { id: "model", label: "Model" },
        { id: "vin", label: "VIN" },
        {
          id: "inspections",
          label: "Inspection Due By:"
        }
      ]
    }
    // {
    //   title: "Ready to Roll",
    //   data: data.filter(c => {
    //     return (
    //       !c.redTag &&
    //       c.defectCount === 0 &&
    //       moment(new Date(c.nextDue)).diff(
    //         new Date(),
    //         "days"
    //       ) > 14
    //     );
    //   }),
    //   statement: "",
    //   icon: ReadytogoIcon
    // }
  ];
  useEffect(() => {}, []);
  // let handleChange = panel => (event, newExpanded) => {
  //   setExpanded(newExpanded ? panel : false);
  // };
  const handleHideLayer = show => {
    setExpanded(show);
    setLayer(false);
  };
  const checkDefects = () => {
    let flag = true;
    Tabs_Array.map(ta => {
      if (ta.data.length > 0 && ["Red Tags", "Defects"].includes(ta.title)) {
        flag = false;
      }
    });
    return flag;
  };
  const checkInspections = () => {
    let flag = true;
    Tabs_Array.map(ta => {
      if (
        ta.data.length > 0 &&
        ["Upcoming Inspections", "Past Due Inspections"].includes(ta.title)
      ) {
        flag = false;
      }
    });
    return flag;
  };
  // const RenderDashboardOld = () => {
  //   return (
  //     <div style={{ marginTop: "25px" }}>
  //       {Tabs_Array.map(dt => {
  //         let bgcolor =
  //           dt.title === "Red Tags"
  //             ? "#F8D7DA"
  //             : dt.title === "Past Due Inspections"
  //             ? "#CCE5FF"
  //             : dt.title === "Defects"
  //             ? "#FFF3CD"
  //             : dt.title === "Upcoming Inspections"
  //             ? "#D1ECF1"
  //             : dt.title === "Ready to Roll"
  //             ? "#D4EDDA"
  //             : "white";
  //         return (
  //           <ExpansionPanel
  //             key={dt.title}
  //             square
  //             expanded={expanded === dt.title}
  //             onChange={handleChange(dt.title)}
  //           >
  //             <ExpansionPanelSummary
  //               aria-controls={`${dt.title}d-content`}
  //               id={`${dt.title}d-header`}
  //               style={{ backgroundColor: bgcolor }}
  //               expandIcon={<ExpandMoreIcon />}
  //             >
  //               <Typography>{dt.title}</Typography>
  //             </ExpansionPanelSummary>
  //             <ExpansionPanelDetails>
  //               <DataTable rows={dt.data} />
  //             </ExpansionPanelDetails>
  //           </ExpansionPanel>
  //         );
  //       })}
  //     </div>
  //   );
  // };
  const RenderDashboard = () => {
    return (
      <div style={{ marginTop: "25px" }}>
        {Tabs_Array.map(dt => {
          if (dt.title === expanded) {
            return (
              <ExpansionPanel
                key={dt.title}
                square
                expanded={expanded === dt.title}
              >
                <ExpansionPanelSummary
                  aria-controls={`${dt.title}d-content`}
                  id={`${dt.title}d-header`}
                  style={{ cursor: "default" }}
                  expandIcon={<CloseIcon onClick={() => setLayer(true)} />}
                >
                  <Typography>{dt.title}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <DataTable rows={dt.data} heads={dt.heads} table={dt.table} />
                </ExpansionPanelDetails>
              </ExpansionPanel>
            );
          } else {
            return <div></div>;
          }
        })}
      </div>
    );
  };
  const RenderOverviewLayer = () => {
    return (
      <div>
        <Row>
          <Col sm={2}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <Typography variant="body2">Fleet Status:</Typography>
            </div>
          </Col>
          <Col sm={6}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: "18px"
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center"
                }}
              >
                {Tabs_Array.map(ta => (
                  <React.Fragment key={ta.tag}>
                    {ta.data.length > 0 && (
                      <React.Fragment>
                        <Tooltip title={ta.title} placement="top">
                          <img
                            style={{
                              cursor: "pointer"
                            }}
                            src={ta.icon}
                            width="16%"
                            height="16%"
                            onClick={() => handleHideLayer(ta.title)}
                          />
                        </Tooltip>
                        {ta.tag === "due" &&
                          critical.data.length > 0 &&
                          critical.data && (
                            <Tooltip title={critical.title} placement="top">
                              <img
                                style={{
                                  cursor: "pointer"
                                }}
                                src={critical.icon}
                                width="16%"
                                height="16%"
                                onClick={() => handleHideLayer(ta.title)}
                              />
                            </Tooltip>
                          )}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ))}
                {/* {critical.data.length > 0 && (
                  <img src={RedtagIcon} width="16%" height="16%" />
                )} */}
                {notReady.length === 0 && (
                  <Tooltip title="Ready To Go" placement="top">
                    <img src={ReadytogoIcon} width="16%" height="16%" />
                  </Tooltip>
                )}
              </div>
            </div>{" "}
            <div
              style={{
                border: "2px solid black",
                padding: "5%",
                margin: "auto",
                width: "50%"
              }}
            >
              <Typography variant="body2">
                <span>
                  {checkDefects() ? (
                    <DoneIcon
                      style={{
                        margin: "-8px 8px",
                        color: "green"
                      }}
                    />
                  ) : (
                    <CloseIcon
                      style={{
                        margin: "-8px 8px",
                        color: "red"
                      }}
                    />
                  )}
                </span>{" "}
                No Defects{" "}
              </Typography>
              <Typography variant="body2">
                {" "}
                <span>
                  {checkInspections() ? (
                    <DoneIcon
                      style={{
                        margin: "-8px 8px",
                        color: "green"
                      }}
                    />
                  ) : (
                    <CloseIcon
                      style={{
                        margin: "-8px 8px",
                        color: "red"
                      }}
                    />
                  )}
                </span>{" "}
                No Inspections Due{" "}
              </Typography>
            </div>
          </Col>
          <Col sm={1}></Col>
          <Col sm={2}>
            <List
              dense
              style={{
                width: "100%",
                maxWidth: "320",
                margin: "0px 10px"
              }}
            >
              <ListItem style={{ padding: "2px" }}>
                <ListItemText style={{ fontSize: "13px" }}>
                  Vehicles
                </ListItemText>
                <ListItemSecondaryAction>
                  {data.length > 0 ? (
                    <Link to="/company">{data.length}</Link>
                  ) : (
                    <span style={{ textDecoration: "underline" }}>
                      {" "}
                      {data.length}{" "}
                    </span>
                  )}
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem style={{ padding: "2px" }}>
                <ListItemText style={{ fontSize: "13px" }}>
                  Drivers
                </ListItemText>
                <ListItemSecondaryAction>
                  <span style={{ textDecoration: "underline" }}>
                    {" "}
                    {Team.Drivers && Team.Drivers.length}{" "}
                  </span>
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem style={{ padding: "2px" }}>
                <ListItemText style={{ fontSize: "13px" }}>
                  Technicians
                </ListItemText>
                <ListItemSecondaryAction>
                  <span style={{ textDecoration: "underline" }}>
                    {" "}
                    {Team.Technicians && Team.Technicians.length}{" "}
                  </span>
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem style={{ padding: "2px" }}>
                <ListItemText style={{ fontSize: "13px" }}>
                  Dispatchers
                </ListItemText>
                <ListItemSecondaryAction>
                  <span style={{ textDecoration: "underline" }}>
                    {" "}
                    {Team.Dispatchers && Team.Dispatchers.length}{" "}
                  </span>
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem style={{ padding: "2px" }}>
                <ListItemText style={{ fontSize: "13px" }}>
                  Outside Mechanics
                </ListItemText>
                <ListItemSecondaryAction>{"__"}</ListItemSecondaryAction>
              </ListItem>
              <ListItem style={{ padding: "2px" }}>
                <ListItemText style={{ fontSize: "13px" }}>
                  Tire Vendors
                </ListItemText>
                <ListItemSecondaryAction>{"__"}</ListItemSecondaryAction>
              </ListItem>
            </List>
          </Col>
          <Col sm={1}></Col>
        </Row>
        <Row
          style={{
            padding: "25px"
          }}
        >
          {" "}
          <Typography variant="subheading">
            {/* {critical.data.length > 0 && (
              <div
                style={{
                  display: "block",
                  marginLeft: "20px",
                  paddingBottom: "12px"
                }}
              >
                {`You Have ${critical.data.length} ${
                  critical.data.length > 1 ? `vehicles` : `vehicle`
                } ${critical.statement} ---`}
                <span
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    color: "blue"
                  }}
                  onClick={() => handleHideLayer(critical.title)}
                >
                  {" "}
                  View Here
                </span>
              </div>
            )} */}
            {Tabs_Array.map((ta, index) => {
              if (ta.data.length > 0) {
                return (
                  <div
                    style={{
                      display: "block",
                      marginLeft: "20px",
                      paddingBottom: "12px"
                    }}
                    key={ta.title}
                  >
                    {`You Have ${ta.data.length} ${
                      ta.data.length > 1 ? `vehicles` : `vehicle`
                    } ${ta.statement} ---`}
                    <span
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        color: "blue"
                      }}
                      onClick={() => handleHideLayer(ta.title)}
                    >
                      {" "}
                      View Here
                    </span>
                  </div>
                );
              }
            })}
          </Typography>
          {notReady.length === 0 && (
            <React.Fragment>
              <Col sm={2} />
              <Col sm={6}>
                <Typography variant="title">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      paddingLeft: "18px"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center"
                      }}
                    >
                      Your Fleet is Ready
                    </div>
                  </div>
                </Typography>
              </Col>
              <Col sm={4} />
            </React.Fragment>
          )}
        </Row>
      </div>
    );
  };
  if (layer) {
    return <RenderOverviewLayer />;
  } else return <RenderDashboard />;
}



// WEBPACK FOOTER //
// ./src/customers/NewDashboard.js